// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submission_history[data-v-2ab267ce]{border:1px solid #ccc}@media only screen and (min-width:1224px){.submission_history[data-v-2ab267ce]{max-width:75%}}.submission_history tr[data-v-2ab267ce]:nth-of-type(odd){background-color:#fbfbfb}.submission_history tr td[data-v-2ab267ce]{border-bottom:none!important}.view_details_btn[data-v-2ab267ce]{color:#33a79d;text-decoration:none};", ""]);
// Exports
module.exports = exports;
